<template>
  <div class="app-container">
    <div class="top">
      <div style="background-color: #00c792">
        <p>今日课程报名付费数</p>
        <h3>{{ msg.course_order_count }}</h3>
      </div>
      <div style="background-color: #5555ff">
        <p>考试报名数</p>
        <h3>{{ msg.exam_count }}</h3>
      </div>
      <div style="background-color: #00557f">
        <p>证书下发数</p>
        <h3>{{ msg.certificate_count }}</h3>
      </div>
      <div style="background-color: #ff5500">
        <p>用户新增数</p>
        <h3>{{ msg.user_count }}</h3>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="title"><span>工作台</span><span></span></div>
        <div class="menu-list">
          <div v-for="item in meneList" class="item" @click="toPage(item)">
            <div class="icon">
              <i :class="item.iconClass"></i>
            </div>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title"><span>付费概览</span><span></span></div>
        <div ref="chart" v-loading="loading" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { indexData } from "../../api/analysis.js";
export default {
  data() {
    return {
      loading: false,
      charts: "",
      msg: {},
      meneList: [],
    };
  },
  mounted() {
    const menus = localStorage.getItem("mymenus");
    if (menus) {
      this.meneList = JSON.parse(menus);
    }
    this.getList();
    console.log(menus);
    this.charts = this.$echarts.init(this.$refs.chart);
  },
  methods: {
    getList() {
      indexData().then((res) => {
        if (res) {
          this.msg = res;
          this.charts.setOption(this.createOption(res.tu), true);
        }
      });
    },
    toPage(item) {
      let path = item.route;
      if (Array.isArray(item.children) && item.children.length > 0) {
        path = item.children[0].route;
      }
      this.$router.push({
        path: path,
      });
    },
    createOption(res) {
      // const res = [
      //     { value: '12', name: '今日收款' },
      //     { value: '22', name: '今日退款' },
      //     { value: '33', name: '待收款' },
      //     { value: '44', name: '延期未收款' }
      // ]
      const option = {
        // title: {
        //     text: 'Referer of a Website',
        //     subtext: 'Fake Data',
        //     left: 'center'
        // },
        tooltip: {
          trigger: "item",
          // formatter: val => {
          //     console.log(val)
          //     return '证书名称：' + val.name + '<br/>相关标签数量：' + val.value + '<br/>占比：' + val.percent + '%'
          // }
        },
        legend: {
          // orient: 'vertical',
          right: "center",
          bottom: "bottom",
          width: "70%",
        },
        series: [
          {
            name: "付费概览",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            data: res,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.app-container {
  height: 100%;
}
.menu-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 16%;
    text-align: center;
    margin: 20px 0;
    .icon {
      width: 80px;
      height: 80px;
      font-size: 30px;
      margin: 5px auto;
      color: #20b979;
      background-color: #f5f5f5;
      border: 1px solid #eee;
      border-radius: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.top {
  display: flex;
  justify-content: space-between;
  & > div {
    height: 200px;
    text-align: center;
    width: 24%;
    font-size: 25px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    p {
      font-size: 16px;
    }
  }
}
.bottom {
  height: calc(100% - 220px);
  display: flex;
  padding-top: 10px;
  .left {
    width: 70%;
    border: 1px solid #bbb;
    padding: 10px;
    box-sizing: border-box;
  }
  .right {
    flex: 1;
    border: 1px solid #bbb;
    margin-left: 10px;
    padding: 10px;
    box-sizing: border-box;
    .chart {
      width: 100%;
      height: calc(100% - 100px);
    }
  }
}
</style>
